export default "__VITE_ASSET__63ffea8b__"